import React, { useEffect, useState } from "react";
import { Card, Button, Typography, Dropdown, Menu, Space } from "antd";
import ReactApexChart from "react-apexcharts";
import {
  PlusOutlined,
  ArrowRightOutlined,
  CalendarOutlined,
  DownOutlined,
} from "@ant-design/icons";

import PainLevel1 from "../graphics/painLevels/1.svg";
import PainLevel2 from "../graphics/painLevels/2.svg";
import PainLevel3 from "../graphics/painLevels/3.svg";
import PainLevel4 from "../graphics/painLevels/4.svg";
import PainLevel5 from "../graphics/painLevels/5.svg";
import PainLevel6 from "../graphics/painLevels/6.svg";
import PainLevel7 from "../graphics/painLevels/7.svg";
import PainLevel8 from "../graphics/painLevels/8.svg";
import PainLevel9 from "../graphics/painLevels/9.svg";
import PainLevel10 from "../graphics/painLevels/10.svg";
import { ApexOptions } from "apexcharts";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { getAveragePainRating } from "../redux-toolkit/slices/dashboardSlice";
import DashboardDateFilter from "./DashboardDateFilter";
import { formatDate } from "../helpers/date";

const { Title, Text } = Typography;

const DashboardPainRating = () => {
  const [filter, setFilter] = useState<string>("7");

  const dispatch = useAppDispatch();
  const {
    isError,
    isRatingApiLoading,
    overAllAverageRating,
    averagePainRatings,
    averagePainRatingDates,
    lastRecordedEntryDate,
  } = useSelector((state: RootState) => state.dashboard);
  useEffect(() => {
    dispatch(getAveragePainRating(filter));
  }, []);
  const onFilterChange = (filter: string) => {
    setFilter(filter);
    dispatch(getAveragePainRating(filter));
  };
  const series = [
    {
      name: "Pain Rating",
      data: averagePainRatings,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "line",
      height: 100,
      toolbar: { show: false },
      zoom: { enabled: false },
      background: "#E0E7EB", // Light background color as per the screenshot
    },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: ["#18373E"], // Dark blue line color
    },
    markers: {
      size: 5,
      colors: ["#8EB2C5"], // Light blue marker fill color
      strokeColors: "#1E3A48", // Dark blue marker stroke color
      strokeWidth: 3,
    },
    xaxis: {
      categories: averagePainRatingDates,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    grid: {
      show: false,
    },
    tooltip: {
      enabled: true,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "solid",
      colors: ["#E0E7EB"], // Background fill color to match the screenshot
    },
  };

  const menu = (
    <Menu>
      <Menu.Item key="1">Past 7 days</Menu.Item>
      <Menu.Item key="2">Past 14 days</Menu.Item>
      <Menu.Item key="3">Past 1 month</Menu.Item>
      <Menu.Item key="3">Past 3 month</Menu.Item>
    </Menu>
  );

  const painLevelSvgMap: { [key: number]: string } = {
    1: PainLevel1,
    2: PainLevel2,
    3: PainLevel3,
    4: PainLevel4,
    5: PainLevel5,
    6: PainLevel6,
    7: PainLevel7,
    8: PainLevel8,
    9: PainLevel9,
    10: PainLevel10,
  };

  return (
    <Card>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Space
          align="center"
          style={{ justifyContent: "space-between", width: "100%" }}
        >
          <Title level={3}>Pain rating</Title>
          {/* <Dropdown overlay={menu} trigger={["click"]}>
            <Button type="text">
              {" "}
              Past 7 days <CalendarOutlined />
            </Button>
          </Dropdown> */}
          <DashboardDateFilter value={filter} onChange={onFilterChange} />
        </Space>
        <Text style={{ color: "#1E1E1E" }}>
          Last entry{" "}
          {lastRecordedEntryDate
            ? formatDate(lastRecordedEntryDate.createdAt)
            : ""}
        </Text>
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={100}
        />
        <Space
          align="center"
          style={{ justifyContent: "space-between", width: "100%" }}
        >
          <Text style={{ color: "#1E1E1E" }}>Average pain rating</Text>
          <Space align="center">
            <Title level={3} style={{ margin: 0 }}>
              {overAllAverageRating}
            </Title>
            <img
              src={
                painLevelSvgMap[
                  overAllAverageRating > 0 ? overAllAverageRating : 1
                ]
              }
              alt={`Pain Level ${overAllAverageRating}`}
              style={{ width: "24px", height: "24px" }}
            />
          </Space>
        </Space>
        <Space style={{ justifyContent: "space-between", width: "100%" }}>
          <Button
            type="link"
            icon={<ArrowRightOutlined />}
            style={{ color: "#1E1E1E" }}
          >
            View More
          </Button>
          <Button
            type="default"
            icon={<PlusOutlined />}
            style={{ color: "#1E1E1E" }}
          >
            Add entry
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

export default DashboardPainRating;
